import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from 'scoreboard/main.hbs'
import globals from 'scoreboard/components/globals'
import conductor from 'scoreboard/components/conductor'
import appDisplay from 'scoreboard/components/app-display'
import Resizer from 'scoreboard/components/resizer'
import svg from './svg.hbs'
import checkboxSvg from './checkbox-svgs.hbs'
import permissions from 'scoreboard/components/permissions'
import license from 'scoreboard/components/license'
import alerts from 'scoreboard/components/alerts'
import pendingMetricValueApprovals from 'scoreboard/home/metric-approvals/pending-metric-value-approvals'
import GlobalSearch from 'scoreboard/global-search/global-search'
import bookmarks from 'scoreboard/bookmarks/bookmarks'
import guard from 'scoreboard/components/unsaved/guard'
import requiresOrg from 'scoreboard/components/requires-org'
import mobile from 'scoreboard/components/mobile'
import constants from 'scoreboard/components/constants'
import sections from 'scoreboard/components/sections'
import config from 'scoreboard/components/config'
import layoutManager from 'scoreboard/components/layout-manager'
import user from 'scoreboard/components/user'
import menuManager from 'scoreboard/menu-manager'
import Tooltip from 'scoreboard/components/tooltip'
import * as websocket from 'scoreboard/components/websocket'
import BusyButton from 'scoreboard/components/busy-button'
import briefingsLayoutManager from 'scoreboard/briefings/briefings-layout-manager'
import showAlertBubble from 'scoreboard/alerts/show-alert-bubble'
import CurrentUserTooltipView from 'scoreboard/components/current-user-tooltip-view'
import projects from 'scoreboard/projects/projects'
import * as Version from 'scoreboard/components/version'
import {hasViewableAdminItems} from './admin/has-viewable-admin-items'
import { setCSSVariable } from 'scoreboard/components/css-variable'
const { isV5, isV6 } = Version

// Value that ensures the resizer doesn't squeeze the .display-pane to anything
// less than the amount specified in width
const RESIZER_BOUNDARY = constants.MIN_DISPLAY_PANE_WIDTH

// Set the CSS variable for the minimum display pane width (measurements.scss)
setCSSVariable('--min-display-pane-width', constants.MIN_DISPLAY_PANE_WIDTH)

let previousImpersonatedUserLabel
var MainView = Backbone.View.extend({

	// this.el is the main <body> element
	tagName: 'body',

	events: {
		'click .toggle-collapsed': 'toggleHeadCollapsed',
		'click .toggle-nav-collapsed': 'toggleNavCollapsed',
		'click .nav-expander': 'toggleNavCollapsed',
		'click .head-pane li[data-section]': 'clickSection',
		'click .mobile-nav .mobile-app-selector': 'toggleMobileMenus',
		'click .head-pane .global-search': 'globalSearch',
		'click .top-pane .global-search': 'globalSearch',
		'click .hamburger': 'mobileMenu',
		'click .mobile-dismiss-overlay': 'mobileMenu',
		'mouseenter .is-collapsed .head-pane-menu-item': 'showHeadPaneMenuItemTooltip',
		'click .end-impersonation' : 'onEndImpersonation',
		'click .top-pane .current-user': 'onCurrentUserClick',
		'click .top-pane .library-toggle': 'onLibraryOptionClick',
		'click .top-pane .is-selected .projects-toggle': 'onProjectsToggleClick',
		'click .top-pane .org-nav-toggle': 'onOrgNavToggleClick'
	},

	initialize: function(options) {
		this.options = options || {}
		_.bindAll(this, 'documentClick')

		this.listenTo(Backbone.history, 'route', (router, name, args) => {
			// If the menu-manager hasn't setup its navTreeExpander, go ahead and
			// tell it to set it up so the nav pane will expand/contract properly #26617
			if (_.isNil(menuManager.navTreeExpander)) {
				menuManager.setupTreeExpander()
			}
		})

		// triggered by app-display after we know a new nav view was set
		this.listenTo(Backbone, 'nav:success route:success', firstLoad => {
			let section = conductor.section()
			this.highlightSection(section)
			// If this is the first time the app has loaded
			this.firstLoad = firstLoad
			// Hide the nav pane when on the home page
			let isHome = section === 'home'
			this.navDisplayPane?.toggleClass('is-hiding-nav-pane', isHome)
		})

		// Listen for when the display pane has just rendered (after route change)
		this.listenTo(appDisplay, 'render:display', function(){
			if(mobile.isMobileWidth() && layoutManager){
				// Need to wait an extra second for the .sticky-footer to assume its true height
				// since it's used insidse _adjustMobileDisplay()
				process.nextTick(() => this._adjustMobileDisplay())
			}
		}.bind(this))

		this.listenTo(Backbone, 'change:unread', ({numUnread}) =>
			this.renderMainBubble(numUnread, null))
		this.listenTo(Backbone, 'change:numPending', ({numPending}) =>
			this.renderMainBubble(null, numPending))
		this.listenTo(Backbone, 'decrement:unread', () =>
			this.renderMainBubble(null, null, true))

		this.listenTo(Backbone, 'change:mode', this.changeMode.bind(this))
		this.listenTo(Backbone, 'empty:tree', this._emptyTree.bind(this))
		this.listenTo(Backbone, 'datasets:drilldown:done', this.highlightSection.bind(this, 'datasets'))

		// Listen for when we'll need to close the mobile menu and dismiss the
		// nav/org panes. (Ex. After selecting a search result on mobile)
		this.listenTo(Backbone, 'mobile:toggle-mobile-menu', function(closeMenu) {
			this.toggleMobileMenus()
			this.mobileMenu({
				closeMenu: closeMenu
			})
		})

		this.listenTo(Backbone, 'reset:display', this.resize.bind(this))
		this.listenTo(Backbone, 'edit:domain-object', function(model) {
			if (model.domainType === 'organization' &&
				model.id == globals.orgId) {
				menuManager.updateOrganizationMenu(model.get('label'))
			}
		}.bind(this))
	},

	render: function() {
		// // important: .append() and don't .empty() so #icon-error-marker sticks around
		// Use .append() instead of .prepend() to keep all svg's at the top of
		// the DOM and prevent a blank space at the bottom of an export view
		this.$el.toggleClass('disable-transitions', true)
		this.$el.append(svg(),
			checkboxSvg(), template({
				quickScore: config.quickScore,
				displayStrategyMaps: config.displayStrategyMaps,
				// loggedInAsBanner will pass in the previously impersonated user label
				// to be shown briefly while sliding out. If there was no previously
				// impersonated user (like when first logging into the app), we don't
				// need to pass in any data.
				impersonatedUserLabel: user.impersonator ? user.label : previousImpersonatedUserLabel,
				showPreviousImpersonatedUser: !user.impersonator && previousImpersonatedUserLabel,
				projectsEnabled: projects.isVisible(),

				// #58309 in V5, the admin profile page is the top admin section
				// for every user. In V6, the top admin section could vary. In
				// V6, let the admin router determine and select the top
				// section.
				adminHref: isV5() ? '/admin/profile' : '/admin'
			})
		)

		this.endImpersonationButton = new BusyButton({
			el: this.$('.end-impersonation')
		})

		// If we're not in the mobile orientation, give the .nav-pane it's left
		// positioning based on the size of the .head-pane. This is done merely to
		// prevent a sluggish load feeling #23318. Once resize() is called, this
		// might be overriden, but that's ok.
		if (!mobile.isMobileOrientation()) {
			this.$('.nav-pane').css('inset-inline-start', this.$('.head-pane').width())
		}
		this.$el.toggleClass('disable-transitions', false)
		this.changeMode()

		// #24350 combine the number of unread alerts and pending metrics awaiting
		// approval
		this.renderMainBubble(alerts.unreadAlerts, pendingMetricValueApprovals.numPending)

		// Setup our Layout Manager which takes care of changing the layout of the screen.
		// We use this primarily in order to collapse the head/nav panes and enter fullscreen mode.
		layoutManager.setup()
		// Setup our Menu Manager which takes care of the deploying and hiding
		// of the left nav menus
		menuManager.readDOM()
		menuManager.setup()
		// Setup our Briefings Layout Manager which takes care of the changing of layout
		// inside the briefings section. Other parts of the app need access to this manager
		// and that's why it's initialized and setup here in main.js
		briefingsLayoutManager.setup()

		layoutManager.changeLayoutForUri().then(() => {
			this._assignReferences()
			this._initializeDisplay()
			this.loggedInAsBanner
				.toggleClass('is-selected', !_.isNil(user.impersonator))
				.removeClass('has-no-transition')
		})

		$(document).on('click', this.documentClick)

		return this
	},

	renderMainBubble: function(unread, numPending, decrement) {
		const unreadValue = unread === null ? alerts.unreadAlerts : unread
		const pendingValue = numPending === null ? pendingMetricValueApprovals.numPending : numPending
		const count = (_.isFinite(unreadValue) ? unreadValue : 0) + (_.isFinite(pendingValue) ? pendingValue : 0)
		showAlertBubble(this, '.main', count - (decrement ? 1 : 0))
	},

	/**
	 * VISUAL COMPONENTS
	 * These vars are set here, saving off important parts of the screen
	 * for use throughout main.js.
	 */
	_assignReferences: function() {
		this.contentPanes = this.$('.slide-pane, .display-pane')
		this.displayPane = this.$('.display-pane')
		this.navPane = this.$('.nav-pane')
		this.organizationPane = this.$('.org-pane')
		this.projectPane = this.$('.project-pane')
		this.headPane = this.$('.head-pane')
		this.menuWrapper = this.$('.menu-wrapper')
		this.projectOrganizationMenu = this.$('.project-organization-menu')
		this.rootNode = $('html')
		this.navDisplayPane = $('.nav-display-pane')
		this.loggedInAsBanner = this.$('.logged-in-as-banner')
		if (isV6()) {
			this.topNav = this.$('.top-pane')
		}
	},

	setupResizer: function() {
		if (this.resizer) return
		// setup resizer that changes relative sizes of nav and display panes
		this.resizer = new Resizer({
			container: this.navPane,
			grid: this.navDisplayPane,
			gridAdjustment: true,
			secondaryMenuContainer: this.menuWrapper,
			maxWidth: this.headPane.width() + RESIZER_BOUNDARY,
			minWidth: constants.NAV_PANE_MIN_WIDTH,
			el: this.$('.resize-handle')
		})
		this.resizer.on('resize', _.bind(this.resize, this, true))
		this.resizer.on('stopResize', this.stopResize.bind(this))
	},

	_initializeDisplay: function () {
		if (isV5()) {
			// setup resizer that changes relative sizes of nav and display panes
			this.resizer = new Resizer({
				container: this.navPane,
				secondaryMenuContainer: this.menuWrapper,
				el: this.$('.resize-handle')
			})
		}

		if (isV6()) {
			// The grid layout causes dimensions to be innacurate when the page
			// first loads. We can wait until the user interacts with the
			// resizer before we set it up to insure accuracy.
			this.$('.resize-handle').one('mouseenter', () => this.setupResizer())
		}

		this.secure()

		// SETUP RESIZE HANDLERS
		// call resize whenever display pane width changes
		$(window).resize(_.bind(this.resize, this, false))
		// Call stopResize() when the browser is done resizing
		$(window).resize(() => {
			setTimeout(() => {
				this.stopResize()
			}, 0)
		})
		if (isV5()) {
			this.resizer.on('resize', _.bind(this.resize, this, true))
			this.resizer.on('stopResize', this.stopResize.bind(this))
		}

		// Wait for the display to get populated before we call resize in order
		// to set initial values
		process.nextTick(() => {
			this.resize()
			if (isV5()) {
				let maxWidth = this.headPane.width() + RESIZER_BOUNDARY
				this.resizer.setMaxWidth(maxWidth)
			}
		})

		// Apply .is-out-of-view to the .org-pane/.project-pane so they're totally hidden (layout.scss)
		// initially as well as after they're done transitioning away.
		this.organizationPane.addClass('is-out-of-view')
		this.organizationPane.on('transitionend', e => {
			e.stopPropagation()
			this.organizationPane.toggleClass('is-out-of-view', !menuManager.organizationPaneVisible())
		})
		this.projectPane.addClass('is-out-of-view')
		this.projectPane.on('transitionend', e => {
			e.stopPropagation()
			this.projectPane.toggleClass('is-out-of-view', !menuManager.projectPaneVisible())
		})

		// Append .is-touch-moving to the body when a touchmove event occurs on body.
		// Nix the class after the touch-move is done. We can use this do differenciate
		// between touches meant to select and touches meant to move/scroll
		this.$el.on('touchmove', function (e) {
				this.$el.toggleClass('is-touch-moving', true)
				// If there's a text input focused (not the hidden one),
				// shift focus to the hidden input so that the cursor doesn't
				// stick/lag/ghost while scrolling.
				if ((document.activeElement.type == 'text' || document.activeElement.type == 'textarea') &&
					!document.activeElement.readOnly && !document.activeElement.classList.contains('mobile-hidden-input')) {
					this.activeElement = document.activeElement
					this.$('.mobile-hidden-input')
						.css('top', e.pageY)
						.focus()
				}
			}.bind(this))
			.on('touchend', function (e) {
				this.$el.toggleClass('is-touch-moving', false)
				// Once done scrolling, if there was a previous active element,
				// re-focus it
				this.activeElement && this.activeElement.focus()
				// Remove this.activeElement. Otherwise it will store the previously
				// focused input  even if it wasn't focused to begin with
				delete this.activeElement
				this.$('.mobile-hidden-input').blur()
			}.bind(this))

		// When the nav pane expands, trigger a 'scroll' event on the contentPanes which closes any
		// select menu's that might be open. Otherwise, those select menu's might overlap the nav pane.
		Backbone.on('navPane:expanded', () => {
			this.contentPanes.each((i, el) => el.dispatchEvent(new Event('scroll')))
		})
	},

	/**
	 * Triggered when the app switches between modes
	 */
	changeMode: function() {
		this.$el
			.removeClass('install-mode ' +
						 'configure-mode ' +
						 'operational-mode ')
			.addClass(globals.mode + '-mode')
		// in case the license changed,
		this.secure()
	},

	// Toggle the expand/collapse state of the head pane
	toggleHeadCollapsed: function() {
		layoutManager.toggleHeadCollapsed().then(() => {
			// We're done collapsing/expanding the head, so set reset the display pane to correctly
			// fit the new width it's been adjusted to. Be sure to toggle transitions OFF beforehand
			// since the adjustment to the new width should be snappy and not use any transitions.
			layoutManager.toggleTransitions(false)
			// #17543 don't do resize() logic until CSS display classes (like display-large) have been applied
			layoutManager.resize()
			appDisplay.resize()
			menuManager.resize()
			layoutManager.toggleTransitions(true)
		})
	},

	// Toggle the expand/collapse state of the nav pane
	toggleNavCollapsed: function() {
		if (!layoutManager.isNavCollapsed()) {
			this.navPane.trigger('toggleCollapse')
		}

		// Disable the collapse/expand button until the collapse/expand is over with
		this.$('.toggle-nav-collapsed').addClass('soft-disable')

		layoutManager.toggleNavCollapsed().then(() => {
			layoutManager.toggleTransitions(false)
			// #17543 don't do resize() logic until CSS display classes (like display-large) have been applied
			layoutManager.resize()
			this.$('.toggle-nav-collapsed').removeClass('soft-disable')
			appDisplay.resize()
			layoutManager.toggleTransitions(true)
		})
	},

	documentClick: function(e) {
		// If no selection is specified yet and we clicked on a section marker,
		// don't continue in order to allow for selecting an org/project #22594
		var section = $(e.target).closest('li[data-section]').data('section')
		if (menuManager.organizationNav && section && requiresOrg(section)) {
			return
		}

		// If the following requirements are met, we want to call this.highlightSection() to highlight the correct section
		if (menuManager.organizationPaneVisible() // The org-pane is visible
			&& !this.organizationPane[0].contains(e.target) // We didn't click the org-pane
			&& !this.projectOrganizationMenu[0].contains(e.target)  // We didn't click the project-organization-menu
			&& !$('.mobile-organization-selector')[0].contains(e.target) // We didn't click the mobile organizations selector
			&& ($('.tooltip').length > 0 && !$('.tooltip')[0].contains(e.target)) // We didn't click a nav tooltip menu
			&& !this.$el.hasClass('is-dialog-visible')) { // There aren't any dialogs visible
			this.highlightSection(conductor.section())
		}

		menuManager.documentClick(e)
	},

	/**
	 * Highlights the given section in the head pane
	 * @param {String} section The section to navigate to
	 */
	highlightSection: function(section) {
		if (!this.headPane) return
		if (isV6()) {
			let libraryButtonContainer =
				this.topNav.find(`[data-section='library'] .toggle-container`)
			// Store width before removing it
			let prevWidth = libraryButtonContainer.width()
			// Remove width to get new width
			libraryButtonContainer.css('width', '')

			// Remove all active classes and set it on the correct item below
			this.topNav.find('li, .library-toggle').removeClass('is-selected')
			let isLibrary = _.includes(constants.LIBRARY_SECTIONS, section)

			if (isLibrary) {
				this.topNav.find(`[data-section='library']`)
					.addClass('is-selected')
				layoutManager.toggleHeadCollapsed(null, false)
				this.libraryButtonWidth =
					libraryButtonContainer[0].getBoundingClientRect().width
			} else {
				this.topNav.find('li').removeClass('is-selected')
				this.topNav.find(`[data-section='${section}']`)
					.addClass('is-selected')
				layoutManager.toggleHeadCollapsed(null, true)
				this.libraryButtonWidth =
					this.topNav.find('.library-toggle').width() +
					constants.STANDARD_MARGIN
			}

			// Don't set a fixed width whe the page first renders.
			if (!this.firstLoad) {
				// Apply a fixed width that matches what it was before the text
				// was changed. This is necessary so the CSS transition works.
				libraryButtonContainer.width(prevWidth)
				// Now that the old width is applied, apply a new fixed width
				// that matches the new text width.
				libraryButtonContainer.width(this.libraryButtonWidth)
			}
			this.firstLoad = false
		}

		this.headPane.find('li').removeClass('is-selected')
		this.headPane.find('[data-section=' + section + ']').addClass('is-selected')
		menuManager.changeSectionContent()
		layoutManager.toggleProjectOrganizationMenu(requiresOrg(section))
		this.$el.toggleClass('is-admin-page', section == 'admin')
		this.headPane.toggleClass('is-displaying-admin', section == 'admin')
	},

	// callback after user clicks on a section
	clickSection: function(e) {
		guard.conditionallyRun(() => {
			let section = $(e.currentTarget).data('section')
			let oldSection = this.$('.head-pane li.is-selected').data('section')

			// #21290 force reload when clicking on same section again
			// #22110 but for admin, send them to the profile page so users can
			// always log out with just 2 clicks
			if (section === oldSection && section != 'admin') {
				// don't follow the sp-navigate link
				e.stopPropagation()
				// #56131 don't let the browser refresh the page
				e.preventDefault()
				// reload the display pane
				conductor.reload()
				// reload the nav pane
				if (appDisplay.navView() && appDisplay.navView().show) {
					appDisplay.navView().show({id: conductor.id(), force: true})
				}

				return
			}

			// If the menuManager handled all that needed to be handled from here to take care of
			// the section change, don't continue on.
			if (menuManager.handleSectionChange(section)) {
				return
			}

			if (requiresOrg(section)) {
				// Since there's a global org id and project id, we're good to go. Go ahead and officialy
				// navigate to the desired section here.
				this.isChangingRoute = true
				conductor.navigate('organizations/' + globals.orgId + '/' + sections.toUrl(section), { trigger: true })
			}
			this.highlightSection(section)
			this.toggleMobileMenus()
		})
	},

	// handles toggling the visibility of the org and head panes, which can't
	// both be visible at once on mobile devices
	toggleMobileMenus: function() {
		if (mobile.isMobileMenuVisible()) {
			menuManager.hideOrganizationPane()
			if (this.headPane.hasClass('is-visible')) {
				this.headPane.removeClass('is-visible')
				this.$('.mobile-app-selector').removeClass('is-selected')
			} else {
				this.headPane.addClass('is-visible')
				this.$('.mobile-app-selector').addClass('is-selected')
			}
		}
	},

	// secure the display by hiding stuff the user doesn't have permission to view
	secure: function() {
		this.$('.icon-config').toggle(permissions.viewAdmin())
		// #58310 hide the settings button in V6 if the user doesn't have permission
		// use has-viewable-admin-items instead of viewAdmin() because the settings

		if (isV6()) {
			hasViewableAdminItems().then((hasItems) => {
				this.$('li.settings').toggle(hasItems)
			})
		}
		// if the user has no bookmarks and no permission to modify bookmarks
		if ((!permissions.bookmarks() && bookmarks.count() == 0) || user.isStrictViewer()) {
			this.$('[data-section=bookmarks]').hide()
		}
		// note: with #48947, license.forms is based on license.datasets
		// #54374 - don't hide datasets and forms, we will be displaying info page
		// if not licensed
		var sections = [ 'scorecards', 'dashboards', 'initiatives', 'briefings', 'files', 'reports' ]
		_.each(sections, function(section) {
			this.$('[data-section=' + section + ']').toggle(license[section])
		}.bind(this))
		// #20509 public read only user shouldn't see the unread alerts indicator
		if (user.model.id == config.publicReadOnlyUserId) {
			this.$('.alert-bubble.main').remove()
		}
	},

	/**
	 * Toggles the mobile menu visibiliy.
	 * @param args - because mobileMenu() is invoked from a click event and direct
	 * call, the closeMenu flag is embedded in an object - the args param needs to be easily
	 * distinguishable from the click event.
	 */
	mobileMenu: function(args) {
		layoutManager.toggleMobileMenu(mobile.isMobileMenuVisible() || args.closeMenu).then(() => {
			this.displayPane.find('.autofocus').focus().removeClass('autofocus')
			this._adjustMobileDisplay()
		})
	},

	_adjustMobileDisplay: function() {
		var stickyFooter = this.$('.sticky-footer')
		// Position absolutely positioned sticky-footer if it exists
		if(stickyFooter.length) {
			layoutManager.toggleTransitions(false)
			stickyFooter.css('inset-inline-start', mobile.isMobileMenuVisible() ? this.navPane.width() : 0)
			// If the footer sticks to the bottom, adjust the body so that it isn't
			// covered by it while scroling
			if (this.$('.table-hack footer').length > 0) {
				// The footer is contained within the .table-hack container. When
				// we're in the mobile width layout, apply a bottom margin to the
				// display-pane-body to ensure the sticky footer is visible. Outside
				// the mobile width layout, the table-hack styling takes care of making
				// sure the footer is visible, so no margin-bottom needed.
				let margin = mobile.isMobileWidth() ? stickyFooter.outerHeight() + constants.STANDARD_MARGIN : 0
				this.$('.table-hack').css('height', '100%')
					.find('.display-pane-body').css('margin-bottom', margin)
			} else {
				// The footer is outside the .table-hack container, use the .table-hack's height
				// in order to ensure the sticky footer is visible
				this.$('.table-hack').css('height', `calc(100% - ${stickyFooter.outerHeight()}px`)
			}
			layoutManager.toggleTransitions(true)
		}
	},

	// Every time the window is resized or the resize handle is dragged, there are
	// multiple parts of the screen who's positions need to be directly manipulated.
	// Comments are included inline to make it clear what's happenening.
	resize: function(dragHandleResize) {
		// If we are in briefings presentation mode and it isn't in a paused state, we don't want to
		// update any of the elements we normally adjust, because all that is handled in briefings-layout-manager.js:resize()
		if (this.$el.hasClass(constants.BRIEFING_MODE_PRESENTATION)
			&& !this.$el.hasClass(constants.BRIEFING_MODE_IS_PAUSED)) {
			layoutManager.resize()
			appDisplay.resize()
			return
		}

		// While in desktop view, we only need to set the headPane width once. This allows us to set the correct
		// head pane width, even if the browser started in mobile view.
		if (!mobile.isMobileOrientation() && (_.isNil(this.headPaneWidthSet) || this.headPaneWidthSet === 'desktop-ready')) {
			this.headPane.css('width', '')
			// If resize event is not coming out of mobile view, catch the width
			if (this.headPaneWidthSet !== 'desktop-ready') {
				this.headPaneWidthSet = true // Set true to prevent this from running again
				this.headPaneWidth = this.headPane.width()
			}
			// Allow the width to be set by its content and still
			// have a fixed starting point for the css transition to work.
			// In rare instance that user 1. has head pane collapsed. 2. resizes to mobile and back to desktop
			// make sure the collapsed state still looks correct.
			var headPaneWidth = layoutManager.isHeadCollapsed() ? constants.HEAD_PANE_COLLAPSED_WIDTH : _.round(this.headPaneWidth)
			this.headPane.width(headPaneWidth)
		} else if (mobile.isMobileOrientation()) {
			// If in mobile orientation, let our CSS handle it
			this.headPane.css('width', '')
			// If window started in desktop already, we have the head-pane width cached.
			// Setting to "desktop-ready" will prevent all of this from needing to re-catch the width
			if (!_.isNil(this.headPaneWidthSet)) {
				 this.headPaneWidthSet = 'desktop-ready'
			 }
		}

		var navPaneWidth = mobile.isMobileOrientation() ? constants.MOBILE_MENU_WIDTH : this.navPane.width()

		// Prevent org pan from showing at the top if its wider than the orgTitle.
		// No need to resize it gradually. Width will get recalculated when its toggled.
		// Set the org pane to the minium width the nav can be so that it is hidden. Cannot set to 0  because
		// it no longer allows the org pane to keep the current org's scroll position. Issue #9067
		this.organizationPane.removeClass('is-visible')
			.addClass('is-out-of-view')
			.css({
				'top': (this.organizationPane.height() + constants.ORG_PANE_TRANSITION_MARGIN)*-1,
				'width': constants.HEAD_PANE_COLLAPSED_WIDTH + 'px'
			})

		this.projectOrganizationMenu.removeClass('menu-opened')
		layoutManager.toggleTransitions(false)

		// If this is a route change (clicked on new section/navpane object), don't reset
		// the menu (which closes it).
		// If we're resizing the window and are entering the non-mobile orientation,
		// clear the positioning of the nav menus.
		if(!this.isChangingRoute && (mobile.isMobileWidth() != this.wasMobile || mobile.isMobileHeight() != this.wasMobile)) {
			this.rootNode.toggleClass('is-mobile-menu-visible', false)
			this.displayPane.css('inset-inline-start', '')
			_.each([this.menuWrapper, this.navPane], function(item) {
				item.css({
					width: '',
					left: ''
				})
			})
		}

		var leftPosition = 0 // Used to set the left positioning of display pane elements
		if(mobile.isMobileOrientation()) {
			// When we're in the mobile orientation and the menu is visible, we need to
			// move the content panes and fixed footer (if there is one)
			// to the right to make room for it.
			if(mobile.isMobileMenuVisible()) {
				leftPosition = navPaneWidth
			}
			this.contentPanes.css('inset-inline-start', leftPosition)

			// Double check to make sure the navpane and menuwrapper are correctly
			// positioned left to prevent them from peeking out upon mobile device
			// rotation (#9240)
			if(!mobile.isMobileMenuVisible()) {
				this.navPane.css('inset-inline-start', navPaneWidth * -1)
				this.menuWrapper.css('inset-inline-start', navPaneWidth * -1)
			}

			// The header is only fixed when outside mobile so we'll need to clear
			// any left values that may have been assigned
			this.displayPane.find('.display-pane-header').css('inset-inline-start', 0)
			this._adjustMobileDisplay()

			this.$('.slide-pane').css('inset-inline-end', 0)
		} else {
			if (isV5()) {
				// These two elements are manipulated in briefer.js:navItemsPosition.
				// Reset them back to normal here in case they were changed.
				var navDisplayPaneMargin = !layoutManager.isHeadCollapsed() ? this.headPaneWidth : constants.HEAD_PANE_COLLAPSED_WIDTH
				this.navDisplayPane.removeAttr('style').css('margin-inline-start', _.round(navDisplayPaneMargin))
				this.projectOrganizationMenu.css('margin-inline-start', 0)
			}

			// Remove mobile inline styles
			this.$('.table-hack').css({
				'height': '',
				'padding-bottom': ''
			})
			if (isV6()) {
				this.navPane.css('inset-inline-start', 0)
			}

			if(layoutManager.isNavCollapsed()) {
				// When not in the mobile orientation and the nav pane is collapsed,
				// keep the nav pane collapsed and keep the content panes flush with the
				// head pane to the left
				this.navPane.css('inset-inline-start', navPaneWidth * -1)
				this.contentPanes.css('inset-inline-start', 0)
				this.contentPanes.css('inset-inline-end', 0)
				if (isV5()) {
					// The .project-organization-menu might be slid out to the right (when it's displaying the org pane
					// while the .nav-pane is collapsed). Set it back to the normal width here since the .org-pane
					// disappears on resize.
					this.projectOrganizationMenu.css('width', this.headPane.width())
				}
			} else {
				// The dashboard edit screen renders a little differently than other sections when switching organizations.
				// In order to keep the display pane at its correct size when the navPane is expanded, we to keep track of the
				// the navPane's starting width and not use the navPane's expanded width to determine the the display-pane's size.
				this.navPane.on('expanded', (e, width) => this.navPaneStartingWidth = this.navPaneStartingWidth || width)
				this.navPane.on('collapsed', () => delete this.navPaneStartingWidth)
				navPaneWidth = this.navPaneStartingWidth ? this.navPaneStartingWidth : navPaneWidth
				let headPaneWidth = this.headPane.width()
				if (isV5()) {
					// When not in the mobile orientation and the nav pane is NOT collapsed,
					// keep the nav pane shown and ensure the content panes are to the right to make room.
					this.projectOrganizationMenuWidth = this.navPaneStartingWidth ?
						this.navPane.width() + headPaneWidth :
						navPaneWidth + headPaneWidth
					this.projectOrganizationMenu.css('width', this.projectOrganizationMenuWidth)
				}
				this.contentPanes.css('inset-inline-start', navPaneWidth)
				this.contentPanes.css('inset-inline-end', 0)
				this.menuWrapper.css('inset-inline-start', 0)
				this.navPane.css('inset-inline-start', 0)
				// Set the left position of the header ONLY if we're displaying a notes layout.
				if(layoutManager.isNotesLayout()) {
					// Using constants here because this.headPane.outerWidth() returns a value
					// a few pixels off the first time around after it's made visible again
					leftPosition = layoutManager.isHeadCollapsed() ?
						this.navPane.outerWidth() + constants.HEAD_PANE_COLLAPSED_WIDTH :
						this.navPane.outerWidth() + this.headPaneWidth
				} else {
					leftPosition = 0
				}
			}
			this.displayPane.find('.display-pane-header, .sticky-footer').css('inset-inline-start', leftPosition)
			this.$('.display-pane-body').removeAttr('style')
		}

		// #17543 don't do resize() logic until CSS display classes (like display-large) have been applied
		layoutManager.resize()
		appDisplay.resize()
		this.wasMobile = mobile.isMobileOrientation() ? true : false
		this.isChangingRoute = false
		layoutManager.toggleTransitions(true)
		// Resize trees in the nav pane
		_.result(appDisplay.navView(), 'resize')
		menuManager.resize(dragHandleResize || mobile.isMobileOrientation())
	},

	showHeadPaneMenuItemTooltip(e) {
		let currentTarget = $(e.currentTarget)
		this.tooltip = new Tooltip({
			extraClass: 'button-covert-tooltip head-pane-item-tooltip',
			attachTo: e.target,
			content: currentTarget.find('.expanded-text').html(), // use .html() so we can get the alert-bubble content from the home menu item
			ignoreAttachToClick: true,
			placement: 'right',
			arrow: 'center'
		}).render()
		currentTarget.on('mouseleave', () => this.tooltip.remove())
	},

	onCurrentUserClick(e) {
		this.currentUserTooltipView = new CurrentUserTooltipView().render()
		this.currentUserTooltip = new Tooltip({
			content: this.currentUserTooltipView.el,
			attachTo: $(e.currentTarget),
			placement: 'below',
			arrow: 'right',
			extraClass: 'current-user-tooltip is-dark has-bootslide-menu'
		}).render()
	},

	onLibraryOptionClick() {
		let librarySection = this.topNav.find('[data-section=library]')
		if (librarySection.hasClass('is-selected')) return
		this.topNav.find('li').removeClass('is-selected')
		librarySection.addClass('is-selected')
		menuManager.selectOrganization()
	},

	onOrgNavToggleClick() {
		menuManager.showOrganizationsNavTooltip()
	},

	onProjectsToggleClick() {
		menuManager.showProjectsNavTooltip()
	},

	// Handles the stopResize event from the resizer
	stopResize: function() {
		// Call resize() once more to make sure everything is in place
		// https://github.com/SpiderStrategies/Scoreboard/issues/29353
		this.resize()

		this.navPane.toggleClass('is-resizing', false)
		layoutManager.toggleTransitions(true)
	},

	_emptyTree: function(section) {
		if (section === 'organizations') {
			menuManager.updateOrganizationMenu('')
		}
	},

	globalSearch: function() {
		guard.conditionallyRun(() => {
			appDisplay.dialog(new GlobalSearch({ url: 'api/search' }))
		})
	},

	onEndImpersonation: function() {
		this.endImpersonationButton.loading()
		$.post(`api/admin/users/unimpersonate`)
			.then(data => {
				user.assignState(data)
				user.load(data.user)
				Backbone.trigger('unimpersonate')
			})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeChildren()
	},

	removeChildren: function() {
		_.invokeMap([this.finder, this.resizer], 'remove')
		$(document).off('click', this.documentClick)
	}
})

var _view
/**
 * Creates and renders the main view into the body of the DOM.
 *
 * Can be used to effectively restart the entire app by removing content
 * and unregistering listeners.
 */
function start() {
	const body = $('body')

	// Cleanup existing views and events bound to the DOM
	_.invoke(_view, 'removeChildren')
	_.invoke(_view, 'undelegateEvents')
	_.invoke(_view, 'stopListening')
	appDisplay.detach()

	// Reset to the original the state of the body (leave #icon-error-marker alone)
	body.children().filter(':not(svg)').remove()
	body.removeClass('is-dialog-visible')

	// (Re)create
	_view = new MainView({
		el: body
	}).render()
}

/*
These events are fired AFTER the user has been updated in the server's session
and the new user state has been assigned to the client.

Resets the application to account for the current user's permissions.

#27831 explains where to go on login/logout
*/
Backbone.on('impersonate', user => impersonationEvent(user, 'home/welcome'))
Backbone.on('unimpersonate', user => impersonationEvent(user))
function impersonationEvent(user, path) {
	// Store the user info to be shown briefly after signing out of the
	// impersonated user. The top banner gets re-rendered, but we give it the
	// illusion that it just slides out of view by keeping the previous user
	// info showing during the transition.
	if (!_.isNil(user)) previousImpersonatedUserLabel = user.label

	if(_view) {
		start()
		if (path) {
			conductor.navigate(path, {trigger: true})
		} else if (conductor.section() === 'bookmarks') {
			// send them to their first bookmark so they don't get an access denied message
			conductor.navigate('bookmarks', {trigger: true})
		} else {
			// stay on current page
			conductor.reload()
		}
		websocket.reconnectAsCurrentUser()
	}
}

export default MainView
export { start }

MainView.__filename__ = 'main.js'
